import axios from '../../config/axios';


  const apiGetBanner = async () => {

    try {
      const result = await axios.get(`/banner/promotion/list`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiGetStore = async (lat, lng, page, limit) => {

    try {
      const result = await axios.get(`/merchant/list?loc_lat=${lat}&loc_lng=${lng}&cur_page=${page}&per_page=${limit}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }
  


  const apiGetNewStore = async (lat, lng, page, limit) => {

    try {
      const result = await axios.get(`/merchant/new/list?loc_lat=${lat}&loc_lng=${lng}&cur_page=${page}&per_page=${limit}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }


  const apiGetNearStore = async (lat, lng, page, limit) => {

    try {
      const result = await axios.get(`/merchant/near/list?loc_lat=${lat}&loc_lng=${lng}&cur_page=${page}&per_page=${limit}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  export {
    apiGetBanner,
    apiGetStore,
    apiGetNewStore,
    apiGetNearStore
}